import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=56d61e0e&"
import script from "./Participants.vue?vue&type=script&lang=ts&"
export * from "./Participants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports